export const groupMessagesByThreadOrRef = (messages = []) => {
  let nullCounter = 0;

  return messages.reduce((acc, message) => {
    let threadId = message?.parent_ref_id || message?.vendor_thread_id;

    if (
      (threadId === null || threadId === undefined) &&
      message?.status === 'scheduled'
    ) {
      // For scheduled messages,
      threadId = `scheduled-message-${message.id}`;
    } else if (threadId === null || threadId === undefined) {
      threadId = `null-group-${++nullCounter}`;
    }

    if (!acc[threadId]) {
      acc[threadId] = [];
    }

    acc[threadId].push(message);
    return acc;
  }, {});
};
export const atsAssessmentRecordType = 'AtsAssessment';
